module.exports = __webpack_public_path__ + "img/7.ce49c289.jpg";